import React, { useEffect, useId } from 'react';
import { Link } from 'react-router-dom';
import { FaInfoCircle } from 'react-icons/fa';
import { useCookieConsent } from '../../context/CookieConsentContext';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const { bannerOpen, acceptAll, rejectNonEssential } = useCookieConsent();
  const labelId = useId();

  useEffect(() => {
    document.body.classList.toggle('cookie-consent-banner-visible', bannerOpen);
    return () => document.body.classList.remove('cookie-consent-banner-visible');
  }, [bannerOpen]);

  if (!bannerOpen) return null;

  return (
    <div className="cookie-consent-banner" role="region" aria-labelledby={labelId}>
      <div className="cookie-consent-banner-inner">
        <p id={labelId} className="cookie-consent-banner-copy">
          <FaInfoCircle className="cookie-consent-banner-icon" aria-hidden="true" />
          <span>
            This site uses cookies. Visit our <Link to="/cookies">cookies policy page</Link> or click
            the link in any footer for more information and to change your preferences.
          </span>
        </p>
        <div className="cookie-consent-banner-actions">
          <button type="button" className="cookie-consent-banner-btn" onClick={acceptAll}>
            Accept all cookies
          </button>
          <button type="button" className="cookie-consent-banner-btn" onClick={rejectNonEssential}>
            Accept only essential cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
